// extracted by mini-css-extract-plugin
module.exports = {"promotionalTilesComponent":"rX","promotionalTile":"rY","promotionalTileThumb":"rZ","promotionalTileHeader":"r0","promotionalTileCaption":"r1"};